import { useMutation } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import { InviteService } from '../services/invite/invite.service';
import type { IInviteService } from '../services/invite/invite.service.interface';

export function useCreateInviteMagicLink() {
  const service = useInjection<IInviteService>(InviteService);

  return useMutation({
    mutationFn: ({ token, tenantId }: { token: string; tenantId: string }) =>
      service.createMagicLink(token, tenantId),
  });
}
